// ── GLP-1 specific constants ───────────────────────────────────────────────

export const NOVO_NORDISK_DRUGS = [
  'OZEMPIC',
  'WEGOVY',
  'VICTOZA 3-PAK',
  'VICTOZA 2-PAK',
  'RYBELSUS',
  'SAXENDA',
] as const

export const ELI_LILLY_DRUGS = ['TRULICITY', 'MOUNJARO', 'ZEPBOUND'] as const

// ── Re-export shared utilities so existing imports/tests continue to work ──
export {
  PAY_LABEL,
  aggregateYearlyRows,
  aggregateQuarterlyRows,
  parseGenderTotals,
  parseAgeCohorts,
  calcClaimsGrowthPct,
  quarterKeysInCalendarYear,
  avgQuarterlyMetricInYear,
  maxQuarterlyClaimsInYear,
  findFirstQuarterAtLeastTotalPay,
  getTopEntries,
  aggregateManufacturerYearlyData,
  aggregateManufacturerYearlyFromQuarterly,
  aggregateManufacturerYearlyPayFromQuarterly,
  formatQuarterLabel,
  sumClaimsByNames,
  calcSharePct,
  calcInsuredSpendPct,
  findTopAgeCohort,
} from '$lib/utils/report/calculations'

export type { QuarterData, GenderTotals, YearlyAggregates } from '$lib/utils/report/calculations'
